module.exports = {
    expired_1: "Bağlantı süresi doldu",
    limit_time: "Sınırlı süreli teklif ",
    participate: "Ödülünüzü almak için hemen inceleme etkinliğine katılın!",
    exclusive: "Özel",
    reward: "Ödül",
    token: "Token",
    vip: "Gün VIP",
    after_completing: "İncelemeyi ve ekran görüntüsü doğrulamasını tamamladıktan sonra şunları alacaksınız",
    step_1: "<strong style='color: #000000'>Aşağıdaki düğmeye tıklayın</strong> uygulama mağazasını ziyaret etmek ve <strong style='color: #000000'>5 yıldızlı inceleme bırakmak için.</strong>",
    step_2: "İncelemeyi tamamladıktan sonra, lütfen inceleme içeriğinizin <strong style='color: #000000'>ekran görüntüsünü alın</strong>.",
    step_3: "Ödülünüzü almak için <strong style='color: #000000'>ekran görüntüsünü aşağıya yükleyin</strong> ve uygulama içi kimliğinizi gönderin.",
    click_to: "1. Şuraya gitmek için tıklayın: ",
    upload: "2. İnceleme Ekran Görüntüsünü Yükle",
    app_store: "App Store",
    google_play: "Google Play",
    go_to: "Şuraya git: ",
    example: "Ekran görüntüsü örneği",
    upload_screenshot: "Ekran Görüntüsünü Yükle",
    claim: "Ödülü Al",
    verification_inprogress: "Yüklediğiniz için teşekkürler. Ekran görüntünüz mümkün olan en kısa sürede inceleniyor. Lütfen sabırlı olun.",
    verification_success: "Tebrikler! <br/><br/> Ödülünüzü başarıyla aldınız. Ödül, hesabınıza <strong>24 saat içinde</strong> yatırılacaktır. Lütfen bekleyin. <br/><br/> Herhangi bir sorunuz varsa, müşteri hizmetleriyle iletişime geçmekten çekinmeyin.",
    verification_failed: "İnceleme ekran görüntüsü aşağıdaki koşulları karşılamalıdır: <br/><br/> <div style='margin-left: 6px'> 1.Değerlendirme 5 yıldız olmalı ve içerik olumlu olmalıdır. <br/><br/> 2.İnceleme <strong> Apple App Store veya Google Play Store </strong> üzerinde yapılmalıdır. <br/><br/> 3.Ekran görüntüsü, inceleme içeriğini tam olarak göstermelidir, <strong> avatar, kullanıcı adı ve inceleme metni dahil. <strong></div>",
    reupload: "Yeniden yükle",
}